/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Muscle_LabelInputs */

const en_us2_quick_workout_muscle_label = /** @type {(inputs: Quick_Workout_Muscle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which muscle?`)
};

const pt_br2_quick_workout_muscle_label = /** @type {(inputs: Quick_Workout_Muscle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual músculo?`)
};

const es_419_quick_workout_muscle_label = /** @type {(inputs: Quick_Workout_Muscle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué músculo?`)
};

const pt_pt2_quick_workout_muscle_label = /** @type {(inputs: Quick_Workout_Muscle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que músculo?`)
};

const fr_fr2_quick_workout_muscle_label = /** @type {(inputs: Quick_Workout_Muscle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel muscle ?`)
};

const de_de2_quick_workout_muscle_label = /** @type {(inputs: Quick_Workout_Muscle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcher Muskel?`)
};

const it_it2_quick_workout_muscle_label = /** @type {(inputs: Quick_Workout_Muscle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale muscolo?`)
};

/**
* | output |
* | --- |
* | "Which muscle?" |
*
* @param {Quick_Workout_Muscle_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_muscle_label = /** @type {((inputs?: Quick_Workout_Muscle_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Muscle_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_muscle_label(inputs)
	if (locale === "es-419") return es_419_quick_workout_muscle_label(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_muscle_label(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_muscle_label(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_muscle_label(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_muscle_label(inputs)
	return en_us2_quick_workout_muscle_label(inputs)
});
export { quick_workout_muscle_label as "quick-workout.muscle_label" }